import React from 'react';
import { Eye } from 'lucide-react';

const COLORS = ['bg-violet-600', 'bg-blue-600', 'bg-emerald-600', 'bg-amber-600', 'bg-rose-600', 'bg-cyan-600', 'bg-pink-600'];
function colorFor(seed) {
  const s = String(seed || '?');
  let sum = 0;
  for (let i = 0; i < s.length; i++) sum += s.charCodeAt(i);
  return COLORS[sum % COLORS.length];
}
function initial(name, email) {
  const src = (name || email || '?').trim();
  return (src[0] || '?').toUpperCase();
}

/**
 * Pila compacta de avatares para mostrar quién está viendo un recurso.
 * Se usa en el listado lateral (chat + hilos de pedido).
 */
export function ViewersStack({ viewers, max = 2, size = 'xs' }) {
  if (!viewers || viewers.length === 0) return null;
  const sz = size === 'xs'
    ? 'w-4 h-4 text-[9px]'
    : 'w-5 h-5 text-[10px]';
  const show = viewers.slice(0, max);
  const rest = viewers.length - show.length;
  return (
    <span
      className="inline-flex items-center gap-0.5 flex-shrink-0"
      title={viewers.map(v => v.name || v.email || 'Agente').join(', ') + ' está viendo esta conversación'}
      data-testid="viewers-stack"
    >
      <Eye size={9} className="text-amber-400" />
      <span className="flex -space-x-1">
        {show.map((v, idx) => (
          <span
            key={v.agent_id || idx}
            className={`${sz} rounded-full ${colorFor(v.agent_id || v.email)} text-white font-semibold flex items-center justify-center border border-gray-900 ring-1 ring-amber-500/40`}
            data-testid={`viewer-avatar-${v.agent_id || idx}`}
          >
            {initial(v.name, v.email)}
          </span>
        ))}
        {rest > 0 && (
          <span className={`${sz} rounded-full bg-gray-700 text-gray-200 font-semibold flex items-center justify-center border border-gray-900`}>
            +{rest}
          </span>
        )}
      </span>
    </span>
  );
}

/**
 * Banner amarillo en la cabecera de la conversación abierta:
 * "⚠️ Juan está viendo esta conversación ahora"
 */
export function ViewersBanner({ viewers }) {
  if (!viewers || viewers.length === 0) return null;
  const names = viewers.map(v => v.name || v.email || 'Agente');
  const label = names.length === 1
    ? `${names[0]} también está viendo esta conversación ahora mismo`
    : `${names.slice(0, -1).join(', ')} y ${names[names.length - 1]} también están viendo esta conversación`;
  return (
    <div
      data-testid="viewers-banner"
      className="mx-4 mt-2 mb-1 flex items-center gap-2 rounded-lg border border-amber-500/40 bg-amber-500/10 px-3 py-1.5 text-xs text-amber-200"
    >
      <Eye size={13} className="text-amber-400 flex-shrink-0" />
      <span className="flex-1 truncate">{label}</span>
      <span className="flex -space-x-1 flex-shrink-0">
        {viewers.slice(0, 3).map((v, idx) => (
          <span
            key={v.agent_id || idx}
            className={`w-5 h-5 rounded-full ${colorFor(v.agent_id || v.email)} text-white text-[10px] font-semibold flex items-center justify-center border border-amber-900/50`}
          >
            {initial(v.name, v.email)}
          </span>
        ))}
      </span>
    </div>
  );
}
